import ContentLoader from 'react-content-loader'
import { Header } from '../commonStyles'
import Theme from 'shop/theme/types'

type HeaderLoaderProps = {
  theme: Theme
}

const HeaderLoader = ({ theme }: HeaderLoaderProps) => (
  <Header>
    <ContentLoader
      speed={2}
      style={{
        width: '50%',
        height: '50px',
        borderRadius: theme.borderRadius,
        marginTop: '10px'
      }}
    />
  </Header>
)

export { HeaderLoader }
